
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/five-fast-facts",
      function () {
        return require("private-next-pages/five-fast-facts.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/five-fast-facts"])
      });
    }
  